import React, { useEffect, useState, useCallback } from 'react';
import { API_URL } from '../../config';
import { useAuth } from '../../context/AuthContext';
import { GlobalStats, AuditLog } from '../../types/admin';

import Header from '../../components/Header/Header';
import Box from '../../components/Common/Box';
import SiteLayout from '../../layouts/SiteLayout';

const GlobalDashboard: React.FC = () => {
  const { token } = useAuth();
  const [stats, setStats] = useState<GlobalStats | null>(null);
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const statsRes = await fetch(`${API_URL}/v1/admin/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const statsData = await statsRes.json();
      setStats(statsData);

      const logsRes = await fetch(`${API_URL}/v1/admin/logs?limit=5`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const logsData = await logsRes.json();
      setLogs(logsData);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [token, fetchData]);


  return (
    <SiteLayout>
      <Header icon='dashboard' title='Dashboard Global' />
      <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>

        {/* Stats Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '30px' }}>
          <Box>
            <div className="flex flex-center" style={{ padding: '30px' }}>
              <div style={{ fontSize: '40px', marginRight: '20px' }}>🏢</div>
              <div>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#667eea' }}>{stats?.total_tenants || 0}</div>
                <div style={{ fontSize: '14px', color: '#666' }}>Tenants Actifs</div>
              </div>
            </div>
          </Box>

          <Box>
            <div className="flex flex-center" style={{ padding: '30px' }}>
              <div style={{ fontSize: '40px', marginRight: '20px' }}>👥</div>
              <div>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#667eea' }}>{stats?.total_users || 0}</div>
                <div style={{ fontSize: '14px', color: '#666' }}>Utilisateurs Totaux</div>
              </div>
            </div>
          </Box>

          <Box>
            <div className="flex flex-center" style={{ padding: '30px' }}>
              <div style={{ fontSize: '40px', marginRight: '20px' }}>💎</div>
              <div>
                <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#667eea' }}>{stats?.premium_users || 0}</div>
                <div style={{ fontSize: '14px', color: '#666' }}>Utilisateurs Premium</div>
              </div>
            </div>
          </Box>
        </div>
        <Box>
          <div className='box-title box-vertical-padding box-horizontal-padding no-select'>
            Logs Récents
          </div>
          <div className='box-content-height-nobutton'>
            <table className='data-table'>
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Détails</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log, index) => (
                  <tr key={log.id} style={{ backgroundColor: index % 2 === 0 ? 'transparent' : 'var(--bg-hover)' }}>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ fontWeight: 600, color: '#1e293b' }}>{log.action}</span>
                    </td>
                    <td style={{ padding: '12px 16px', color: '#475569' }}>{log.details}</td>
                    <td style={{ padding: '12px 16px', color: '#64748b', fontSize: '13px' }}>
                      {new Date(log.created_at).toLocaleString('fr-FR')}
                    </td>
                  </tr>
                ))}
                {logs.length === 0 && (
                  <tr>
                    <td colSpan={3} style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>
                      📋 Aucun log récent
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Box>
      </div>
    </SiteLayout>
  );
};

export default GlobalDashboard;

